import React, {useState} from 'react';
import DesktopSearchPanelElement3 from './DesktopSearchPanelElement3';
import DesktopSearchPanelElement2 from './DesktopSearchPanelElement2';
import DesktopSearchPanelElement1 from './DesktopSearchPanelElement1';
import 'boxicons';
import search from './img/search.png';
import './stylesMarketplace.css';
import {BuscadorLocalidad} from './BuscadorLocalidad';

/**
 * It's a function that returns a div that contains a div that contains three DesktopSearchPanelElement
 * components and a div that contains an img
 */
function DesktopSearchPanel(props) {
	const {autLocalidades, setAutLocalidades} = props;
	/**
	 * *|CURSOR_MARCADOR|*
	 */
	const filtrar = () => {};

	/* A state that is being used to store the values of the filters. */
	const [Filtro, setFiltro] = useState({
		localidad: '',
		servicio: 'servico',
		distancia: 'distacia',
		precio: 'precio',
	});

	/* It's a destructuring assignment. */
	const {localidad, servicio, distancia, precio} = Filtro;

	return (
		<div className='desktopSearchPanel'>
			<div className='contentDesktopSearchPanelExterior '>
				<div className='contentDesktopSearchPanel'>
					<BuscadorLocalidad
						Filtro={Filtro}
						setFiltro={setFiltro}
						autLocalidades={autLocalidades}
						setAutLocalidades={setAutLocalidades}
					/>
					<DesktopSearchPanelElement2
						className='desktopSearchPanelElement elementDSP'
						maxValue={150}
						minValue={5}
						defaultValue={[50]}
						stepValue={1}
						setFiltro={setFiltro}
						Filtro={Filtro}
					/>
					<DesktopSearchPanelElement3
						className='desktopSearchPanelElement elementDSP'
						maxValue={100}
						minValue={5}
						defaultValue={[10, 20]}
						stepValue={10}
						setFiltro={setFiltro}
						Filtro={Filtro}
					/>
					<div
						className='centrador buttonBuscarDesktopSearchPanelElement dsp3'
						Id='botonFiltrar'
					>
						<div onClick={filtrar}>
							<img src={search} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default DesktopSearchPanel;
